// import React, { useState, useEffect } from "react";
// import "./ApplyForLeave.css";
// import Navbar from "./common/Navbar";
// import Footer from "./common/Footer";
// import Sidebar from "./common/Sidebar";
// import { Grid, Card, CardContent, Typography, Box, Avatar } from "@mui/material";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const LeaveRequestForm = () => {
//   const [leaveType, setLeaveType] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [reason, setReason] = useState("");
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");
//   const [remainingLeaves, setRemainingLeaves] = useState(null);

//   useEffect(() => {
//     const fetchRemainingLeaves = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         if (!token) {
//           setError("No token found. Please log in.");
//           return;
//         }

//         const response = await fetch(
//           `${BASE_URL}/api/employees/leaves/remainingleaves`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Error fetching remaining leaves");
//         }

//         const data = await response.json();
//         setRemainingLeaves(data.remainingLeave);
//         setError("");
//       } catch (err) {
//         console.error("Error:", err);
//         setError("Error fetching remaining leaves");
//       }
//     };

//     fetchRemainingLeaves();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         setError("No token found. Please log in.");
//         return;
//       }

//       const decodedToken = JSON.parse(atob(token.split(".")[1]));
//       const employeeId = decodedToken.employee.id;

//       const requestBody = {
//         employeeId,
//         leaveType,
//         startDate,
//         endDate,
//         reason,
//       };

//       const response = await fetch(`${BASE_URL}/api/leave/requests`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.msg || "Error submitting leave request");
//       }

//       setMessage(data.msg);
//       setError("");
//       setLeaveType("");
//       setStartDate("");
//       setEndDate("");
//       setReason("");

//       window.location.reload();
//     } catch (err) {
//       console.error("Error:", err);
//       setError(err.message || "Error submitting leave request");
//       setMessage("");
//     }
//   };

//   const handleStartDateChange = (e) => {
//     const selectedStartDate = e.target.value;
//     setStartDate(selectedStartDate);
//     if (endDate < selectedStartDate) {
//       setEndDate(selectedStartDate);
//     }
//   };

//   return (
//     <div className="leave-application-container">
//       <Navbar />
//       <Sidebar />

//       <div className="leave-application-content">
//         <div className="leave-application-header">
//           <h2 className="leave-application-title">Leave Application</h2>
//           <p className="leave-application-subtitle">
//             Submit your leave request for approval
//           </p>
//         </div>

//         <div className="leave-application-grid">
//           {/* Leave Balance Card */}
//           <div className="leave-balance-card">
//             <h3 className="leave-balance-title">Your Leave Balance</h3>
//             {remainingLeaves ? (
//               <div className="leave-balance-items">
//                 <div className="leave-balance-item">
//                   <span className="leave-type">Annual Leave</span>
//                   <span className="leave-count">
//                     {remainingLeaves.annualLeave}
//                   </span>
//                 </div>
//                 <div className="leave-balance-item">
//                   <span className="leave-type">Sick Leave</span>
//                   <span className="leave-count">
//                     {remainingLeaves.sickLeave}
//                   </span>
//                 </div>
//                 <div className="leave-balance-item">
//                   <span className="leave-type">Casual Leave</span>
//                   <span className="leave-count">
//                     {remainingLeaves.casualleave}
//                   </span>
//                 </div>
//                 <div className="leave-balance-item">
//                   <span className="leave-type">Other Leave</span>
//                   <span className="leave-count">{remainingLeaves.Other}</span>
//                 </div>
//               </div>
//             ) : (
//               <div className="leave-balance-loading">
//                 Loading leave balances...
//               </div>
//             )}
//           </div>

//           {/* Leave Request Form */}
//           <div className="leave-request-card">
//             <h3 className="leave-request-title">Request New Leave</h3>
//             <form onSubmit={handleSubmit} className="leave-request-form">
//               <div className="form-group">
//                 <label htmlFor="leaveType" className="form-label">
//                   Leave Type
//                 </label>
//                 <select
//                   id="leaveType"
//                   value={leaveType}
//                   onChange={(e) => setLeaveType(e.target.value)}
//                   className="form-select"
//                   required
//                 >
//                   <option value="">Select Leave Type</option>
//                   <option value="earned">Annual/Earned Leave</option>
//                   <option value="sick">Sick Leave</option>
//                   <option value="casual">Casual Leave</option>
//                   <option value="other">Other</option>
//                 </select>
//               </div>

//               <div className="form-row">
//                 <div className="form-group">
//                   <label htmlFor="startDate" className="form-label">
//                     Start Date
//                   </label>
//                   <input
//                     type="date"
//                     id="startDate"
//                     value={startDate}
//                     onChange={handleStartDateChange}
//                     className="form-input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="endDate" className="form-label">
//                     End Date
//                   </label>
//                   <input
//                     type="date"
//                     id="endDate"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     className="form-input"
//                     required
//                     min={startDate}
//                   />
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label htmlFor="reason" className="form-label">
//                   Reason for Leave
//                 </label>
//                 <textarea
//                   id="reason"
//                   value={reason}
//                   onChange={(e) => setReason(e.target.value)}
//                   className="form-textarea"
//                   rows="4"
//                 />
//               </div>

//               <button type="submit" className="submit-button">
//                 Submit Leave Request
//               </button>

//               {message && (
//                 <div className="alert-message success">{message}</div>
//               )}
//               {error && <div className="alert-message error">{error}</div>}
//             </form>
//           </div>
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default LeaveRequestForm;




/////////////////////Rishabh version start hear

import React, { useState, useEffect } from "react";
import Navbar from "../common/Navbar";
import Sidebar from "../common/Sidebar";
import {
  Grid,
  Card,
  Typography,
  Box,
  TextField,
  MenuItem,
  Button,
  Alert,
} from "@mui/material";
// import { MenuItem, TextField, Grid, Card, Typography, Box, Alert } from "@mui/material";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const LeaveRequestForm = () => {
  const [leaveType, setLeaveType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reason, setReason] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [remainingLeaves, setRemainingLeaves] = useState(null);

  useEffect(() => {
    const fetchRemainingLeaves = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          setError("No token found. Please log in.");
          return;
        }

        const response = await fetch(
          `${BASE_URL}/api/employees/leaves/remainingleaves`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Error fetching remaining leaves");
        }

        const data = await response.json();
        setRemainingLeaves(data.remainingLeave);
        setError("");
      } catch (err) {
        console.error("Error:", err);
        setError("Error fetching remaining leaves");
      }
    };

    fetchRemainingLeaves();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        setError("No token found. Please log in.");
        return;
      }

      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const employeeId = decodedToken.employee.id;

      const requestBody = {
        employeeId,
        leaveType,
        startDate,
        endDate,
        reason,
      };

      const response = await fetch(`${BASE_URL}/api/leave/requests`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.msg || "Error submitting leave request");
      }

      setMessage(data.msg);
      setError("");
      setLeaveType("");
      setStartDate("");
      setEndDate("");
      setReason("");
      window.location.reload();
    } catch (err) {
      console.error("Error:", err);
      setError(err.message || "Error submitting leave request");
      setMessage("");
    }
  };

  const handleStartDateChange = (e) => {
    const selectedStartDate = e.target.value;
    setStartDate(selectedStartDate);
    if (endDate < selectedStartDate) {
      setEndDate(selectedStartDate);
    }
  };

  return (
    <Box sx={{ display: "flex", bgcolor: "#f8fafc", minHeight: "100vh" }}>
      <Sidebar />
      <Box sx={{ flexGrow: 1 }}>
        <Navbar />
        <Box sx={{ p: 3, mt: 6 }}>
          {/* Header */}
          <Box sx={{ mb: 1, mt: 3 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Leave Management
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Submit your leave request for approval
            </Typography>
          </Box>


          {/* Leave Balance Cards */}
          <Grid container spacing={3} sx={{ mb: 5, mt: 0.5 }}>
            {remainingLeaves ? (
              <>
                {[
                  { label: "Annual Leave", value: remainingLeaves.annualLeave },
                  { label: "Sick Leave", value: remainingLeaves.sickLeave },
                  { label: "Casual Leave", value: remainingLeaves.casualleave },
                  { label: "Other Leave", value: remainingLeaves.Other },
                ].map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Card
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        minHeight: 90,
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#334155",
                          fontSize: "14px",
                          fontWeight: 500,
                          mb: 0.3,
                        }}
                      >
                        {item.label}
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "start",
                        }}
                      >
                        <Box sx={{ lineHeight: 1, pt: 0.2 }}>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "22px",
                              mb: 0.2,
                            }}
                          >
                            {item.value}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ fontSize: "11px" }}
                          >
                            days available
                          </Typography>
                        </Box>

                        <Box
                          component="svg"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#1d4ed8"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          sx={{
                            width: 30,
                            height: 30,
                            alignSelf: "flex-start",
                            mt: 0.2,
                          }}
                        >
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                          <line x1="16" y1="2" x2="16" y2="6" />
                          <line x1="8" y1="2" x2="8" y2="6" />
                          <line x1="3" y1="10" x2="21" y2="10" />
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                ))}
              </>
            ) : (
              <Grid item xs={12}>
                <Typography textAlign="center" color="text.secondary">
                  Loading leave balances...
                </Typography>
              </Grid>
            )}
          </Grid>


          {/* Leave Request Form */}
          <Grid container spacing={3}>
            {/* Leave Request Form - Left side */}

            <Grid item xs={12} md={5}>
              <Card sx={{ p: 2.5, borderRadius: 2 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  Request New Leave
                </Typography>

                <Box
                  component="form"
                  onSubmit={handleSubmit}
                  sx={{ display: "flex", flexDirection: "column", gap: 1.5, mt: 1.5 }}
                >
                  {/* Leave Type Dropdown with Image-Like UI */}
                  <TextField
                    select
                    variant="outlined"
                    label="Leave Type"
                    value={leaveType}
                    onChange={(e) => setLeaveType(e.target.value)}
                    required
                    fullWidth
                    size="small"
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            borderRadius: "12px",
                            boxShadow: "0px 4px 16px rgba(0,0,0,0.1)",
                            mt: 1,
                            maxHeight: "250px", // optional scroll height
                          },
                        },
                        disableScrollLock: true, // << IMPORTANT: lets it scroll naturally and hides on page scroll
                      },
                    }}
                    InputProps={{
                      sx: {
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                      },
                    }}
                  >
                    {[
                      { value: "earned", label: "Annual Leave" },
                      { value: "sick", label: "Sick Leave" },
                      { value: "casual", label: "Casual Leave" },
                      { value: "other", label: "Other Leave" },
                    ].map((item, index) => (

                      <MenuItem
                        key={index}
                        value={item.value}
                        sx={{
                          borderRadius: "8px",
                          paddingY: "8px",
                          paddingX: "12px",
                          marginX: "6px",
                          transition: "all 0.2s",
                          "&:hover": {
                            backgroundColor: "grey.50",
                          },
                        }}
                      >
                        {item.label}
                      </MenuItem>
                    ))}

                  </TextField>


                  {/* Start Date */}
                  <TextField
                    type="date"
                    label="Start Date"
                    variant="outlined"
                    value={startDate}
                    onChange={handleStartDateChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    required
                    size="small"
                    InputProps={{
                      sx: {
                        borderRadius: "10px",
                      },
                    }}
                  />

                  {/* End Date */}
                  <TextField
                    type="date"
                    label="End Date"
                    variant="outlined"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    required
                    size="small"
                    inputProps={{ min: startDate }}
                    InputProps={{
                      sx: {
                        borderRadius: "10px",
                      },
                    }}
                  />

                  {/* Reason Field */}
                  <TextField
                    label="Reason for Leave"
                    variant="outlined"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    multiline
                    minRows={2}
                    maxRows={3}
                    fullWidth
                    size="small"
                    InputProps={{
                      sx: {
                        borderRadius: "10px",
                        fontSize: "0.85rem",
                        lineHeight: "1.2rem",
                        padding: "6px 8px",
                      },
                    }}
                  />

                  {/* Submit Button */}
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#1E40AF",
                      color: "white",
                      padding: "6px 12px",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      width: "fit-content",
                      fontSize: "0.8rem",
                    }}
                  >
                    Submit Leave Request
                  </button>

                  {/* Alerts */}
                  {message && (
                    <Alert
                      severity="success"
                      sx={{
                        py: 0.25,
                        fontSize: "0.8rem",
                        lineHeight: "1rem",
                        mt: 0.5,
                      }}
                    >
                      {message}
                    </Alert>
                  )}
                  {error && (
                    <Alert
                      severity="error"
                      sx={{
                        py: 0.25,
                        fontSize: "0.8rem",
                        lineHeight: "1rem",
                        mt: 0.5,
                      }}
                    >
                      {error}
                    </Alert>
                  )}
                </Box>
              </Card>
            </Grid>



            {/* Leave Policy - Right side */}
            <Grid item xs={12} md={7}>
              <Card sx={{ p: 4, borderRadius: 3 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  Leave Policy
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Company leave policies and guidelines
                </Typography>

                <Grid container spacing={4} sx={{ mt: 2 }}>
                  {/* Leave Types */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                      Leave Types
                    </Typography>
                    <Box display="flex" flexDirection="column" gap={2}>
                      {[
                        { type: "Casual Leave", days: "12 days/year" },
                        { type: "Sick Leave", days: "10 days/year" },
                        { type: "Vacation", days: "21 days/year" },
                        { type: "Maternity Leave", days: "⎯ days/year" },
                        { type: "Personal Leave", days: "5 days/year" },
                      ].map((leave, index) => (
                        <Box
                          key={index}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          p={1.2}
                          bgcolor="#f9f9f9"
                          borderRadius={2}
                          sx={{
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                            '&:hover': {
                              bgcolor: "#e6f0ff",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                              transform: "translateY(-2px)",
                            }
                          }}
                        >
                          <Typography fontSize="0.9rem" fontWeight={500}>
                            {leave.type}
                          </Typography>
                          <Box
                            px={1.5}
                            py={0.3}
                            bgcolor="#f0f0f0"
                            borderRadius={2}
                            fontSize="0.85rem"
                            fontWeight={500}
                            display="flex"
                            alignItems="center"
                            lineHeight={1}
                          >
                            {leave.days}
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Grid>

                  {/* Important Notes */}
                  {/* <Grid item xs={12} sm={6}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 0.5 }}>
          Important Notes
        </Typography>
        <Box
          component="ul"
          sx={{
            pl: 2.2, // Adjusted for alignment
            mb: 0,
            color: "text.secondary",
            fontSize: "0.85rem",
            lineHeight: 1.6,
            listStyleType: "disc",
          }}
        >
          {[
            "Leave requests must be submitted at least 2 days in advance",
            "Sick leave requires medical certificate for more than 3 days",
            "Vacation leave requires manager approval",
            "Unused casual leave can be carried forward up to 5 days",
            "Maternity leave is as per company policy",
          ].map((note, idx) => (
            <li key={idx} style={{ marginBottom: 6 }}>
              <Typography
                component="span"
                variant="body2"
                color="text.secondary"
                fontSize="0.85rem"
              >
                {note}
              </Typography>
            </li>
          ))}
        </Box>
      </Grid> */}
                <Grid item xs={12} sm={6}>
  <Typography
    variant="subtitle1"
    fontWeight={600}
    gutterBottom
    sx={{ pl: 2.2 }}
  >
    Important Notes
  </Typography>

  <Box
    component="ul"
    sx={{
      pl: 3, // adds padding so bullets aren't flush to left edge
      m: 0,
      listStyleType: 'disc',
    }}
  >
    {[
      "Leave requests must be submitted at least 2 days in advance", 
      "Sick leave requires medical certificate for more than 3 days",
      "Vacation leave requires manager approval",
      "Unused casual leave can be carried forward up to 5 days",
      "Maternity leave is as per company policy",
    ].map((note, idx) => (
      <Typography
        key={idx}
        component="li"
        variant="body2"
        color="text.secondary"
        fontSize="0.85rem"
        sx={{ mb: 1 }}
      >
        {note}
      </Typography>
    ))}
  </Box>
</Grid>


                </Grid>
              </Card>
            </Grid>

          </Grid>


        </Box>
      </Box>
    </Box>
  );
};

export default LeaveRequestForm;
